import { useEffect, useState } from "react"

import { cn } from "@/lib/utils"

// Initials from a pen name — first letter of the first and last word, so
// "Rosa Marlow" → "RM" and a single name → its first letter.
function initialsFor(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return "?"
  if (parts.length === 1) return parts[0][0].toUpperCase()

  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

// Muted monochrome avatar (per DECISIONS §Color — the app overrides the
// prototype's per-person colored chips) with a green online-presence dot ringed
// to the surface so it stays legible over a card. The freelancer's photo shows
// when there is one; initials stand in when there isn't or it fails to load.
export default function FreelancerAvatar({ name, src, size = 52, online = false, className }) {
  const [imageFailed, setImageFailed] = useState(false)

  useEffect(() => {
    setImageFailed(false)
  }, [src])

  const showImage = src && !imageFailed

  return (
    <span className={cn("relative inline-flex shrink-0", className)} style={{ width: size, height: size }}>
      <span
        title={name}
        aria-label={showImage ? undefined : name}
        className="inline-flex items-center justify-center overflow-hidden rounded-full bg-secondary font-bold text-muted-foreground"
        style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}
      >
        {showImage ? (
          <img
            src={src}
            alt={name ? `${name} profile picture` : "Profile picture"}
            className="size-full object-cover"
            onError={() => setImageFailed(true)}
          />
        ) : (
          initialsFor(name)
        )}
      </span>
      {online && (
        <span
          className="absolute right-0 bottom-0 rounded-full border-[2.5px] border-card bg-done"
          style={{ width: Math.max(11, size * 0.24), height: Math.max(11, size * 0.24) }}
        />
      )}
    </span>
  )
}

export { initialsFor }
